import React  , {useState , useEffect}from 'react';
import axios from 'axios';

import {getDroitsAvailable} from '../components/droits.js';
import { ressourcesFamille } from '../components/liste-ressources.js';
import PositiveResult from '../components/positive-result.js';
import NegativeResult from '../components/negative-result.js';

/**
 * Function that display age from
 *  
 * @param int age
 */
const getBirthDateFromAge = function (age) {
	let today = new Date();
	return new Date(today.getFullYear() - age, today.getMonth(), today.getDate() - 1);

};

/**
 * Get individu object
 *
 * @param {*} individu
 */
const getIndividuObject = function (individu) {
	const individuBase = {
	  //"prenom": "Votre 1er enfant",
      "date_naissance": "2018-12-11T23:00:00.000Z",
      "garde_alternee": false,
      "enfant_a_charge": false,
      "scolarite": "inconnue"
	};

	return {
		...individuBase,
		...individu
	};
}
/**
 * Get object with 'demandeur' default data for openfisca
 * 
 * @param {*} demandeur 
 */
const getDemandeurObject = function (demandeur){
	const demandeurBase = {
	    "ass_precondition_remplie": false,
      "aah_restriction_substantielle_durable_acces_emploi": false,
      "gir": "gir_6",
      "rsa_jeune_condition_heures_travail_remplie": false,
      "enfant_a_charge": false,
      "statut_marital": "celibataire",
      "role": "demandeur",
	    "etudiant": false,
      "chomeur_longue_duree": false,
      "handicap": false,
      "inapte_travail": false,
      "enceinte": false,
      "echelon_bourse": -1,
      "nationalite": "FR",
	};
	
	return {
		...demandeurBase,
		...demandeur
	}
}

/**
 * Get prenom enfant
 * 
 * @param string enfantId
 */
const getPrenomEnfant = function (enfantId) {
	const indexEnfant = parseInt(enfantId.slice(-1))-1; 
	const enfNum = (indexEnfant+1) + ( indexEnfant === 0  ? 'er' : 'ème');
	return`Votre ${enfNum} enfant`;
}

/**
 * Get ressources object with standard openfisca dates
 *  
 * @param int|float
 */
const getFormattedRessources = function ( montantAnnuel ) {
	const montantMensuel = montantAnnuel /12;
	const date = new Date();
	let currentYear = date.getFullYear();
	let currentMonth = date.getMonth() + 1;
	let revenuParMois= {};
	for ( let i = 0; i < 12 ; i++ ) {
		let monthString =  `${currentYear}-${('0'+currentMonth).slice(-2)}`;
		revenuParMois[monthString] = montantMensuel;
		currentMonth-=1;
		if (currentMonth == 0){
			currentMonth = 12;
			currentYear -= 1;
		}
	}
	return revenuParMois;
}

export default function Resultats (props) {
	
	const [droit , setDroit] = useState({});
	const [simulationResult , setSimulationResult] = useState(<></>);  // default to positive
	const [loading , setLoading] = useState(true);

	const mapOpenfiscaData =  async ( simulationData ) => {	
		let foyer_fiscal= {};

		let menage = {
			personne_de_reference : ['individu'],
			conjoint:[],
			enfants:[]
		};

		let individus = {
			individu : getDemandeurObject({})
		};

		let famille = {};
		let date = new Date();

		// Data Individus.
		//console.log( 'simulationData : ' , simulationData);
		
		individus.individu.date_naissance = getBirthDateFromAge(simulationData.demandeur.age);
		if (simulationData.demandeur.enCouple) {
			individus.conjoint = {};
			individus.conjoint = getIndividuObject ({
				"date_naissance" : getBirthDateFromAge(simulationData.conjoint.age),
			});
			menage.conjoint = ['conjoint'];
		}
		// Data Foyer fiscal .
		foyer_fiscal.declarants = ['individu'];
		foyer_fiscal.personnes_a_charge = [];

		// Data Famille & Foyer Fiscal.
		famille.en_couple = simulationData.demandeur.enCouple;
		famille.parents = Object.keys(individus); // no child yet
		famille.enfants = [];
		
		if (simulationData.enfants.hasEnfant || simulationData.enfants.hasEnfantGardeAlternee) {
			let nbEnfant = simulationData.enfants.nombreEnfant
			if (simulationData.enfants.hasEnfantGardeAlternee){
				nbEnfant = simulationData.enfants.nombreEnfant + simulationData.enfants.nombreEnfantGardeAlternee  ;
			}
			for ( let x = 1 ; x <= nbEnfant ; x += 1 ) {
				let enfantId = `enfant_${x}`;
				let dataEnfant=  { 
					"prenom" : getPrenomEnfant(enfantId),
					"enfant_a_charge" : true 
				};
				// Enfant en garde alternee
				if (simulationData.enfants.hasEnfantGardeAlternee && x > (nbEnfant-simulationData.enfants.nombreEnfantGardeAlternee)){
					dataEnfant.garde_alternee= true ;
				}

				let enfant = getIndividuObject(dataEnfant);
				foyer_fiscal.personnes_a_charge.push( enfantId );
				famille.enfants.push( enfantId );
				individus[enfantId] = enfant;
				menage.enfants.push(enfantId);
			}
		}

		// Data Logements .
		if ( simulationData.logement != undefined ){
			menage.depcom = simulationData.logement.ville;

			if (simulationData.logement.montantMensualite){
				menage.loyer = simulationData.logement.montantMensualite;
			}

			//if (simulationData.logement.pretPlusUnAn)
			menage.aide_logement_date_pret_conventionne =  (date.getFullYear() - 3).toString() + '-12-31';
			menage.statut_occupation_logement =  simulationData.logement.primoAccedant ? "primo_accedant" : simulationData.logement.situationLogement;
			menage.code_postal = simulationData.logement.codePostal;
			menage.depcom = simulationData.logement.ville;
			menage.logement_conventionne = simulationData.logement.primoAccedant && simulationData.logement.montantMensualite == 0;
		}

		// Data Revenus .
		Object.keys(simulationData.revenus).forEach( (ind) => {
			// 'demandeur' is not present in individus object .
			let personne = ind === 'demandeur' ? 'individu' : ind;
			let revenus = Object.keys(simulationData.revenus[ind]);

			individus[personne].ressources = {};

			revenus.forEach ((revenu)=>{
				let revenuMensuels = getFormattedRessources(simulationData.revenus[ind][revenu]);
				if ( ressourcesFamille.includes(revenu) ) {
					famille[revenu] = revenuMensuels;
				} else {
					individus[personne].ressources[revenu] = revenuMensuels;
				}
			});

		});

		// Pension alimentaire
		if ( simulationData.pension != undefined){
			if (simulationData.pension.touchePension) {
				individus.individu.pensions_alimentaires_versees_individu = simulationData.pension.value
			}
		}

		// data formatting
		let openfiscaData = {
			individus:individus,
			familles : {
				_ : famille
			},
			foyers_fiscaux : {
				_ : foyer_fiscal
			},
			menages : {
				_ : menage
			}
		};

		// Correclty formatting data for API request.
		Object.keys( openfiscaData ).forEach( (key)=>{
			openfiscaData[key] = JSON.stringify( openfiscaData[key]);
		})
		
		return openfiscaData;
	}

	const sendRequestToAideSocialeAPI = async ( openfiscaData ) => {
		//console.log('data sent : ' ,  openfiscaData);
		setLoading(true);
		const url = "https://simulateurs.aide-sociale.fr/simulateur-css/index.php";
		return axios.post( url , openfiscaData)
			.then( (response)=>{
				//console.log(response); 
				return response.data.openfisca;
			})
	}
	
	const setResultFromResponse = async (openfiscaResponse) =>{
		const droits = getDroitsAvailable(openfiscaResponse);
		if ( droits.length > 0 ) {
			// Positive results .

			droits.forEach( (d)=>{
				setDroit(d);
			})
			
			setSimulationResult( true );
			setLoading(false);

		} else {
			// Negative Results
			setSimulationResult(false);
			setLoading(false);

		}
	}

	useEffect( () => {
		mapOpenfiscaData(props.simulationData)
		  .then( sendRequestToAideSocialeAPI )
		  .then( setResultFromResponse );
	} , [] );
	
	const restart = ()=>{
		props.restart();
	}
	return <div id= "resultats" className="sim-form min-height">
		{ ( loading ) ?
			<div className="loading-result">
				<p><div className="loadersmall"></div>Chargement de vos aides ...</p>
			</div> 
			: (simulationResult) ?
				<PositiveResult droit={droit} restart={restart}></PositiveResult> :
				<NegativeResult restart={restart}></NegativeResult>
		}

	</div>;
}
